let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bVqnE")).then(() => parcelRequire('98wGO'));